/* eslint-disable max-len */
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  agGridLicence: 'Using_this_{AG_Grid}_Enterprise_key_{AG-095855}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Worklife_Barometer_ApS}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Howdy_Portal}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Howdy_Portal}_need_to_be_licensed___{Howdy_Portal}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{31_January_2027}____[v3]_[01]_MTgwMTM1MzYwMDAwMA==ed0ab43e5ad824929347b31db9f65aec'
};
